var React = require('react');

function PointsTriangle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2 76.1445L102.576 151.01M2 76.1445L76.3271 81.6717M2 76.1445L125.824 53.1697M102.576 151.01L76.3271 81.6717M102.576 151.01L125.824 53.1697M76.3271 81.6717L125.824 53.1697","stroke":"#553E6B"}));
}

PointsTriangle.defaultProps = {"width":"80","height":"162","viewBox":"0 0 80 162","fill":"none"};

module.exports = PointsTriangle;

PointsTriangle.default = PointsTriangle;
